/**
 * CourseStatusService
 * Service for CourseStatus entity operations
 * Route: api/course-statuses
 */
import { BaseService } from '../base/BaseService';
/**
 * CourseStatusService
 * Handles course status CRUD operations
 */
export class CourseStatusService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? CourseStatusService.DEFAULT_SERVICE_PATH,
            basePath: CourseStatusService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /**
     * Get all course statuses
     * @returns Promise resolving to array of course statuses
     */
    async getAll() {
        const response = await this.getAllRaw();
        return response.data ?? [];
    }
    /**
     * Get all course statuses (raw response)
     * @returns Promise resolving to ResponseData with course statuses
     */
    getAllRaw() {
        const url = this.buildUrl('');
        return this.http.get(url);
    }
    /**
     * Get course status by ID
     * @param id - Status ID
     * @returns Promise resolving to course status or null
     */
    async getById(id) {
        const response = await this.getByIdRaw(id);
        return response.data ?? null;
    }
    /**
     * Get course status by ID (raw response)
     * @param id - Status ID
     * @returns Promise resolving to ResponseData with course status
     */
    getByIdRaw(id) {
        const endpoint = this.getEndpoint('getById', `${id}`);
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
    /**
     * Create a new course status
     * @param status - Status data
     * @returns Promise resolving to created course status
     */
    async create(status) {
        const response = await this.createRaw(status);
        return response.data ?? null;
    }
    /**
     * Create a new course status (raw response)
     * @param status - Status data
     * @returns Promise resolving to ResponseData with created course status
     */
    createRaw(status) {
        const url = this.buildUrl('');
        return this.http.post(url, status);
    }
    /**
     * Update an existing course status
     * @param id - Status ID
     * @param status - Updated status data
     * @returns Promise resolving to updated course status
     */
    async update(id, status) {
        const response = await this.updateRaw(id, status);
        return response.data ?? null;
    }
    /**
     * Update an existing course status (raw response)
     * @param id - Status ID
     * @param status - Updated status data
     * @returns Promise resolving to ResponseData with updated course status
     */
    updateRaw(id, status) {
        const endpoint = this.getEndpoint('update', `${id}`);
        const url = this.buildUrl(endpoint);
        return this.http.put(url, status);
    }
    /**
     * Delete a course status
     * @param id - Status ID
     * @returns Promise resolving to true if successful
     */
    async delete(id) {
        const response = await this.deleteRaw(id);
        return response.success;
    }
    /**
     * Delete a course status (raw response)
     * @param id - Status ID
     * @returns Promise resolving to ResponseData
     */
    deleteRaw(id) {
        const endpoint = this.getEndpoint('delete', `${id}`);
        const url = this.buildUrl(endpoint);
        return this.http.delete(url);
    }
}
CourseStatusService.DEFAULT_SERVICE_PATH = 'resources';
CourseStatusService.BASE_PATH = 'api/course-statuses';
//# sourceMappingURL=CourseStatusService.js.map